import { makeStyles } from "@material-ui/core";
import React, { FunctionComponent, useState } from "react";
import CardCheckedBox from "../checkboxes/CardCheckedBox";
const useStyle = makeStyles({
  container: {
    width: "250px",
    height: "150px",
    display: "flex",
    position: "relative",
    background:
      "linear-gradient(360deg, #E1F5FF 0%, rgba(225, 245, 255, 0) 74.09%)",
    alignItems: "center",
    borderRadius: "0.914em",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  content: {
    padding: "21px 14px",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  checkBtn: {
    top: "5px",
    insetInlineEnd: "5px",
    position: "absolute",
    "& .MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#0e9cf0",
    },
    "& span": {
      padding: "0",
    },
    "& svg": {
      fontSize: "30px",
    },
  },
  titleContainer: {
    textAlign: "center",
    marginTop: "10px",
    "& svg path": {
      fill: "rgb(14, 156, 240)",
    },
  },
  title: {
    color: "rgba(63, 69, 79, 1)",
    fontSize: "1.82em",
    textAlign: "center",
    lineHeight: "1.5em",
    letterSpacing: "0.05625px",
  },
});

interface ReportCardProps {
  icon: JSX.Element;
  title: string;
  isOpen?: boolean;
  onChange?: (checked: boolean) => void;
}

const ReportCard: FunctionComponent<ReportCardProps> = (props) => {
  const styles = useStyle();
  const [isChecked, setisChecked] = useState(false);
  return (
    <div
      className={styles.container}
      style={{ border: isChecked ? "1px solid #0E9CF0" : "1px solid #E2E2E2" }}
    >
      <CardCheckedBox
        type="black"
        isOpen={props.isOpen}
        onClick={props.onChange}
      />
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          {props.icon}
          <h1 className={styles.title}>{props.title}</h1>
        </div>
      </div>
    </div>
  );
};
{
  /* <ReportCard icon={<InitativeIcon size={50}/>} title="Corporate Report" onChange={(val)=>{}}/> */
}

export default ReportCard;
